import { JsonProperty, JsonObject } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';
import { Edito } from '@hermes/api-model-editorial';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * This class define banner properties
 *
 * @dynamic
 */
let BannerItem = class BannerItem extends ModelObject {
    constructor(source) {
        super();
        this.active = undefined;
        this.link = undefined;
        this.cookieTimestamp = undefined;
        this.content = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("active", Boolean, true),
    __metadata("design:type", Boolean)
], BannerItem.prototype, "active", void 0);
__decorate([
    JsonProperty("link", String, true),
    __metadata("design:type", String)
], BannerItem.prototype, "link", void 0);
__decorate([
    JsonProperty("cookie_timestamp", Number, true),
    __metadata("design:type", Number)
], BannerItem.prototype, "cookieTimestamp", void 0);
__decorate([
    JsonProperty("content", String, true),
    __metadata("design:type", String)
], BannerItem.prototype, "content", void 0);
BannerItem = __decorate([
    JsonObject("BannerItem"),
    __metadata("design:paramtypes", [Object])
], BannerItem);

/**
 * This class define banners data properties
 */
let BannersData = class BannersData extends ModelObject {
    constructor() {
        super();
        this.cookie = undefined;
        this.notifications = undefined;
        this.geofiltering = undefined;
    }
};
__decorate([
    JsonProperty("cookie", BannerItem, true),
    __metadata("design:type", BannerItem)
], BannersData.prototype, "cookie", void 0);
__decorate([
    JsonProperty("notifications", [BannerItem], true),
    __metadata("design:type", Array)
], BannersData.prototype, "notifications", void 0);
__decorate([
    JsonProperty("geofiltering", BannerItem, true),
    __metadata("design:type", BannerItem)
], BannersData.prototype, "geofiltering", void 0);
BannersData = __decorate([
    JsonObject("BannersData"),
    __metadata("design:paramtypes", [])
], BannersData);

/**
 * This class describe a footer item
 */
let FooterItemDeprecated = class FooterItemDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        this.itemLabel = undefined;
        this.itemType = undefined;
        this.itemData = undefined;
        this.itemNewTab = false;
        this.itemIsAccessibility = false;
    }
};
__decorate([
    JsonProperty("item_label"),
    __metadata("design:type", String)
], FooterItemDeprecated.prototype, "itemLabel", void 0);
__decorate([
    JsonProperty("item_type"),
    __metadata("design:type", String)
], FooterItemDeprecated.prototype, "itemType", void 0);
__decorate([
    JsonProperty("item_data"),
    __metadata("design:type", String)
], FooterItemDeprecated.prototype, "itemData", void 0);
__decorate([
    JsonProperty("item_new_tab"),
    __metadata("design:type", Boolean)
], FooterItemDeprecated.prototype, "itemNewTab", void 0);
__decorate([
    JsonProperty("item_is_accessibility"),
    __metadata("design:type", Boolean)
], FooterItemDeprecated.prototype, "itemIsAccessibility", void 0);
FooterItemDeprecated = __decorate([
    JsonObject("FooterItem")
], FooterItemDeprecated);

/**
 * This class describe a footer column
 */
let FooterColumnDeprecated = class FooterColumnDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        this.columnLabel = undefined;
        /** Array of footer items */
        this.columnItems = undefined;
    }
};
__decorate([
    JsonProperty("column_label"),
    __metadata("design:type", String)
], FooterColumnDeprecated.prototype, "columnLabel", void 0);
__decorate([
    JsonProperty("column_items", [FooterItemDeprecated]),
    __metadata("design:type", Array)
], FooterColumnDeprecated.prototype, "columnItems", void 0);
FooterColumnDeprecated = __decorate([
    JsonObject("FooterColumn")
], FooterColumnDeprecated);

let FooterHereToHelpItemDeprecated = class FooterHereToHelpItemDeprecated extends ModelObject {
    constructor() {
        super();
        this.days = undefined;
        this.open = undefined;
        this.close = undefined;
        this.timezone = undefined;
    }
};
__decorate([
    JsonProperty("days"),
    __metadata("design:type", String)
], FooterHereToHelpItemDeprecated.prototype, "days", void 0);
__decorate([
    JsonProperty("open"),
    __metadata("design:type", String)
], FooterHereToHelpItemDeprecated.prototype, "open", void 0);
__decorate([
    JsonProperty("close"),
    __metadata("design:type", String)
], FooterHereToHelpItemDeprecated.prototype, "close", void 0);
__decorate([
    JsonProperty("timezone"),
    __metadata("design:type", String)
], FooterHereToHelpItemDeprecated.prototype, "timezone", void 0);
FooterHereToHelpItemDeprecated = __decorate([
    JsonObject("FooterHereToHelpItem"),
    __metadata("design:paramtypes", [])
], FooterHereToHelpItemDeprecated);

let FooterHereToHelpColumnContactsDeprecated = class FooterHereToHelpColumnContactsDeprecated extends ModelObject {
    constructor() {
        super();
        this.phoneNumber = undefined;
        this.description = undefined;
        this.openingItems = [];
    }
};
__decorate([
    JsonProperty("phone_number"),
    __metadata("design:type", String)
], FooterHereToHelpColumnContactsDeprecated.prototype, "phoneNumber", void 0);
__decorate([
    JsonProperty("description", true),
    __metadata("design:type", String)
], FooterHereToHelpColumnContactsDeprecated.prototype, "description", void 0);
__decorate([
    JsonProperty("opening", [FooterHereToHelpItemDeprecated], true),
    __metadata("design:type", Array)
], FooterHereToHelpColumnContactsDeprecated.prototype, "openingItems", void 0);
FooterHereToHelpColumnContactsDeprecated = __decorate([
    JsonObject("FooterHereToHelpColumnContacts"),
    __metadata("design:paramtypes", [])
], FooterHereToHelpColumnContactsDeprecated);

let FooterHereToHelpColumnDeprecated = class FooterHereToHelpColumnDeprecated extends ModelObject {
    constructor() {
        super();
        this.title = undefined;
        this.contacts = [];
    }
};
__decorate([
    JsonProperty("title"),
    __metadata("design:type", String)
], FooterHereToHelpColumnDeprecated.prototype, "title", void 0);
__decorate([
    JsonProperty("contacts", [FooterHereToHelpColumnContactsDeprecated]),
    __metadata("design:type", Array)
], FooterHereToHelpColumnDeprecated.prototype, "contacts", void 0);
FooterHereToHelpColumnDeprecated = __decorate([
    JsonObject("FooterHereToHelpColumn"),
    __metadata("design:paramtypes", [])
], FooterHereToHelpColumnDeprecated);

let FooterLegalLinkDeprecated = class FooterLegalLinkDeprecated extends ModelObject {
    constructor() {
        super();
        this.linkText = undefined;
        this.linkHref = undefined;
    }
};
__decorate([
    JsonProperty("link_text"),
    __metadata("design:type", String)
], FooterLegalLinkDeprecated.prototype, "linkText", void 0);
__decorate([
    JsonProperty("link_href"),
    __metadata("design:type", String)
], FooterLegalLinkDeprecated.prototype, "linkHref", void 0);
FooterLegalLinkDeprecated = __decorate([
    JsonObject("FooterLegalLink"),
    __metadata("design:paramtypes", [])
], FooterLegalLinkDeprecated);

let FooterSocialNetworkDeprecated = class FooterSocialNetworkDeprecated extends ModelObject {
    constructor() {
        super();
        this.name = undefined;
        this.machineName = undefined;
        this.isWechat = false;
        this.href = undefined;
        this.isCn = false;
    }
};
__decorate([
    JsonProperty("name"),
    __metadata("design:type", String)
], FooterSocialNetworkDeprecated.prototype, "name", void 0);
__decorate([
    JsonProperty("machine_name"),
    __metadata("design:type", String)
], FooterSocialNetworkDeprecated.prototype, "machineName", void 0);
__decorate([
    JsonProperty("is_wechat"),
    __metadata("design:type", Boolean)
], FooterSocialNetworkDeprecated.prototype, "isWechat", void 0);
__decorate([
    JsonProperty("href"),
    __metadata("design:type", String)
], FooterSocialNetworkDeprecated.prototype, "href", void 0);
__decorate([
    JsonProperty("is_cn"),
    __metadata("design:type", Boolean)
], FooterSocialNetworkDeprecated.prototype, "isCn", void 0);
FooterSocialNetworkDeprecated = __decorate([
    JsonObject("FooterSocialNetwork"),
    __metadata("design:paramtypes", [])
], FooterSocialNetworkDeprecated);

/**
 * This class describe footer data
 */
let FooterDataDeprecated = class FooterDataDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        /** Array of footer columns */
        this.columns = undefined;
        this.socialNetworks = undefined;
        this.hereToHelp = undefined;
        this.legalLinks = undefined;
    }
};
__decorate([
    JsonProperty("columns", [FooterColumnDeprecated], true),
    __metadata("design:type", Array)
], FooterDataDeprecated.prototype, "columns", void 0);
__decorate([
    JsonProperty("social_networks", [FooterSocialNetworkDeprecated], true),
    __metadata("design:type", Array)
], FooterDataDeprecated.prototype, "socialNetworks", void 0);
__decorate([
    JsonProperty("here_to_help", FooterHereToHelpColumnDeprecated, true),
    __metadata("design:type", FooterHereToHelpColumnDeprecated)
], FooterDataDeprecated.prototype, "hereToHelp", void 0);
__decorate([
    JsonProperty("legal_links", [FooterLegalLinkDeprecated], true),
    __metadata("design:type", Array)
], FooterDataDeprecated.prototype, "legalLinks", void 0);
FooterDataDeprecated = __decorate([
    JsonObject("FooterData")
], FooterDataDeprecated);

var MenuEntryType;
(function (MenuEntryType) {
    MenuEntryType["gridMenuEntry"] = "grid";
    MenuEntryType["landitoMenuEntry"] = "landito";
    MenuEntryType["ecommerceStoryMenuEntry"] = "ecommerce_story";
    MenuEntryType["storyMenuEntry"] = "story";
    MenuEntryType["separatorMenuEntry"] = "line_separator";
})(MenuEntryType || (MenuEntryType = {}));

/**
 * @dynamic
 */
let GridMenuEntry = class GridMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.pimCode = undefined;
        this.hasVisibleProducts = undefined;
        this.edito = new Edito();
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "tid", void 0);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "parentId", void 0);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "type", void 0);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "eventType", void 0);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "name", void 0);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "path", void 0);
__decorate([
    JsonProperty("pimCode", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "pimCode", void 0);
__decorate([
    JsonProperty("hasVisibleProducts", Boolean, true),
    __metadata("design:type", Boolean)
], GridMenuEntry.prototype, "hasVisibleProducts", void 0);
__decorate([
    JsonProperty("edito", Edito, true),
    __metadata("design:type", Edito)
], GridMenuEntry.prototype, "edito", void 0);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], GridMenuEntry.prototype, "menuEntryList", void 0);
GridMenuEntry = __decorate([
    JsonObject("GridMenuEntry"),
    __metadata("design:paramtypes", [Object])
], GridMenuEntry);

/**
 * @dynamic
 */
let LanditoMenuEntry = class LanditoMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.gridPath = undefined;
        this.pimCode = undefined;
        this.hasVisibleProducts = undefined;
        this.edito = new Edito();
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "tid", void 0);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "parentId", void 0);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "type", void 0);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "eventType", void 0);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "name", void 0);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "path", void 0);
__decorate([
    JsonProperty("gridPath", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "gridPath", void 0);
__decorate([
    JsonProperty("pimCode", String, false),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "pimCode", void 0);
__decorate([
    JsonProperty("hasVisibleProducts", Boolean, false),
    __metadata("design:type", Boolean)
], LanditoMenuEntry.prototype, "hasVisibleProducts", void 0);
__decorate([
    JsonProperty("edito", Edito, true),
    __metadata("design:type", Edito)
], LanditoMenuEntry.prototype, "edito", void 0);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], LanditoMenuEntry.prototype, "menuEntryList", void 0);
LanditoMenuEntry = __decorate([
    JsonObject("LanditoMenuEntry"),
    __metadata("design:paramtypes", [Object])
], LanditoMenuEntry);

/**
 * @dynamic
 */
let EcommerceStoryMenuEntry = class EcommerceStoryMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.pimCode = undefined;
        this.hasVisibleProducts = undefined;
        this.edito = new Edito();
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "tid", void 0);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "parentId", void 0);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "type", void 0);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "eventType", void 0);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "name", void 0);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "path", void 0);
__decorate([
    JsonProperty("pimCode", String, false),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "pimCode", void 0);
__decorate([
    JsonProperty("hasVisibleProducts", Boolean, true),
    __metadata("design:type", Boolean)
], EcommerceStoryMenuEntry.prototype, "hasVisibleProducts", void 0);
__decorate([
    JsonProperty("edito", Edito, true),
    __metadata("design:type", Edito)
], EcommerceStoryMenuEntry.prototype, "edito", void 0);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], EcommerceStoryMenuEntry.prototype, "menuEntryList", void 0);
EcommerceStoryMenuEntry = __decorate([
    JsonObject("EcommerceStoryMenuEntry"),
    __metadata("design:paramtypes", [Object])
], EcommerceStoryMenuEntry);

/**
 * @dynamic
 */
let StoryMenuEntry = class StoryMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "tid", void 0);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "parentId", void 0);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "type", void 0);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "eventType", void 0);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "name", void 0);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "path", void 0);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], StoryMenuEntry.prototype, "menuEntryList", void 0);
StoryMenuEntry = __decorate([
    JsonObject("StoryMenuEntry"),
    __metadata("design:paramtypes", [Object])
], StoryMenuEntry);

/**
 * @dynamic
 */
let SeparatorMenuEntry = class SeparatorMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], SeparatorMenuEntry.prototype, "tid", void 0);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], SeparatorMenuEntry.prototype, "parentId", void 0);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], SeparatorMenuEntry.prototype, "type", void 0);
SeparatorMenuEntry = __decorate([
    JsonObject("SeparatorMenuEntry"),
    __metadata("design:paramtypes", [Object])
], SeparatorMenuEntry);

/**
 * Format only needed fields for categorie suggestion to send to RDR
 */
let CategorySuggestion = class CategorySuggestion extends ModelObject {
    constructor() {
        super(...arguments);
        this.label = undefined;
        this.pimCode = undefined;
        this.results = undefined;
        this.categoriesId = undefined;
    }
};
__decorate([
    JsonProperty("label", String, true),
    __metadata("design:type", String)
], CategorySuggestion.prototype, "label", void 0);
__decorate([
    JsonProperty("pimCode", String, true),
    __metadata("design:type", String)
], CategorySuggestion.prototype, "pimCode", void 0);
__decorate([
    JsonProperty("results", Number, true),
    __metadata("design:type", Number)
], CategorySuggestion.prototype, "results", void 0);
__decorate([
    JsonProperty("categoriesId", String, true),
    __metadata("design:type", String)
], CategorySuggestion.prototype, "categoriesId", void 0);
CategorySuggestion = __decorate([
    JsonObject("CategorySuggestion")
], CategorySuggestion);

/**
 * Format only needed fields for product suggestion to send to RDR
 */
let ProductSuggestion = class ProductSuggestion extends ModelObject {
    constructor() {
        super(...arguments);
        this.label = undefined;
        this.sku = undefined;
        this.slug = undefined;
        this.productSetType = undefined;
        this.secondId = undefined;
        this.url = undefined;
    }
};
__decorate([
    JsonProperty("label", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "label", void 0);
__decorate([
    JsonProperty("sku", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "sku", void 0);
__decorate([
    JsonProperty("slug", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "slug", void 0);
__decorate([
    JsonProperty("productSetType", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "productSetType", void 0);
__decorate([
    JsonProperty("secondId", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "secondId", void 0);
__decorate([
    JsonProperty("url", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "url", void 0);
ProductSuggestion = __decorate([
    JsonObject("ProductSuggestion")
], ProductSuggestion);

/**
 * Format only needed fields for search suggestions to send to RDR
 */
let SearchSuggestion = class SearchSuggestion extends ModelObject {
    constructor() {
        super(...arguments);
        this.categories = undefined;
        this.products = undefined;
    }
};
__decorate([
    JsonProperty("categories", [CategorySuggestion], true),
    __metadata("design:type", Array)
], SearchSuggestion.prototype, "categories", void 0);
__decorate([
    JsonProperty("products", [ProductSuggestion], true),
    __metadata("design:type", Array)
], SearchSuggestion.prototype, "products", void 0);
SearchSuggestion = __decorate([
    JsonObject("SearchSuggestion")
], SearchSuggestion);

export { BannerItem, BannersData, CategorySuggestion, EcommerceStoryMenuEntry, FooterColumnDeprecated, FooterDataDeprecated, FooterHereToHelpColumnContactsDeprecated, FooterHereToHelpColumnDeprecated, FooterHereToHelpItemDeprecated, FooterItemDeprecated, FooterLegalLinkDeprecated, FooterSocialNetworkDeprecated, GridMenuEntry, LanditoMenuEntry, MenuEntryType, ProductSuggestion, SearchSuggestion, SeparatorMenuEntry, StoryMenuEntry };
